
import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import StandCategoryList from './StandCategoryList';
import StandCategoryModal from './StandCategoryModal';
import { StandCategory } from './types';

const StandCategoryContainer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<StandCategory | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const handleOpenAdd = () => {
    setSelectedItem(null);
    setModalOpen(true);
  };

  const handleOpenEdit = (item: StandCategory) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setRefreshTrigger(prev => !prev); 
  };

  return (
    <>
      <Breadcrumbs mainTitle="Stand Categories" parent="Core Settings" />
      <Container fluid>
        <Row>
          <Col md="12">
            <StandCategoryList
              onAdd={handleOpenAdd}
              onEdit={handleOpenEdit}
              refresh={refreshTrigger}
            />
          </Col>
        </Row>
        <StandCategoryModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          initialData={selectedItem}
        />
      </Container>
    </>
  );
};

export default StandCategoryContainer;
